import React, { useState, useEffect } from "react";
import { MdAccessTime, MdStars } from "react-icons/md";
import { useAuth } from "context/AuthContext";
import { COMPANY_MOTTO, COMPANY_MOTTO_HEADER } from "config";

const SidebarCard = () => {
    const { user } = useAuth();
    const [time, setTime] = useState(new Date());

    // Saat güncelleme logic'i (Sadece personel/admin ise çalışır, kaynak tüketmez)
    useEffect(() => {
        if (user?.role !== "customer") {
            const timer = setInterval(() => setTime(new Date()), 1000);
            return () => clearInterval(timer);
        }
    }, [user?.role]);

    const isCustomer = user?.role === "customer";

    return (
        <div className="relative mt-8 flex w-[200px] flex-col items-center justify-center rounded-[20px] border border-gray-200 bg-gray-50 px-4 py-4 text-center dark:border-white/10 dark:bg-navy-700">
            {/* İkon Alanı */}
            <div className="absolute -top-5 flex h-10 w-10 items-center justify-center rounded-full bg-brand-500 border-4 border-white text-white dark:border-navy-800 shadow-md">
                {isCustomer ? <MdStars className="h-5 w-5" /> : <MdAccessTime className="h-5 w-5" />}
            </div>

            <div className="mt-3">
                {isCustomer ? (
                    // Müşteri Görünümü: Motto Header ve Motto
                    <>
                        <h5 className="text-sm font-bold text-navy-700 dark:text-white leading-tight">
                            {COMPANY_MOTTO_HEADER}
                        </h5>
                        <p className="mt-1 text-[10px] font-medium text-gray-500 dark:text-gray-400">
                            {COMPANY_MOTTO}
                        </p>
                    </>
                ) : (
                    // Personel/Admin Görünümü: Canlı Saat ve Alt Bilgi
                    <>
                        <h5 className="text-lg font-black text-brand-500 dark:text-white font-mono">
                            {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </h5>
                        <p className="mt-0.5 text-[10px] font-bold uppercase tracking-widest text-gray-400">
                            {COMPANY_MOTTO_HEADER || "Sistem Aktif"}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default SidebarCard;